import { useCallback, useState } from "react";
import { Button, Fade } from "@mui/material";
import { useAssociations } from "../../contexts";
import { PageHeader, AssociationCard } from "../../components";
import * as s from "./styles";
import { Draggable } from "../../components/draggable";
import SearchAssociations from "./search-associations";
import { Association } from "../../@data";
import { removeAccents } from "../../utils";
const Associations = () => {
  const { associations, categories } = useAssociations();
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [searchResults, setSearchResults] = useState<Association[] | null>(
    null
  );

  const handleSelectCategory = useCallback(
    (newCategory: string) => {
      if (newCategory === selectedCategory) setSelectedCategory(null);
      else setSelectedCategory(newCategory);
    },
    [selectedCategory]
  );

  const searchAssociations = useCallback(
    (searchText: string) => {
      if (!searchText) setSearchResults(null);
      else {
        const normalizedSearch = removeAccents(searchText.toLowerCase());
        const filteredArray = associations.filter((obj) => {
          const nameWithoutAccents = removeAccents(obj.name).toLowerCase();
          const descriptionWithoutAccents = removeAccents(
            obj.description
          ).toLowerCase();
          const nameMatch = nameWithoutAccents.includes(normalizedSearch);
          const descriptionMatch =
            descriptionWithoutAccents.includes(normalizedSearch);
          return nameMatch || descriptionMatch;
        });
        const sortedArray = filteredArray.sort((a, b) => {
          const indexOfA = removeAccents(a.name)
            .toLowerCase()
            .indexOf(normalizedSearch);
          const indexOfB = removeAccents(b.name)
            .toLowerCase()
            .indexOf(normalizedSearch);
          return indexOfA - indexOfB;
        });
        if (sortedArray) setSearchResults(sortedArray);
      }
    },
    [associations, setSearchResults]
  );

  const currentList = searchResults ? searchResults : associations;

  const associationsList = selectedCategory
    ? currentList.filter((a) => a.category === selectedCategory)
    : currentList;

  return (
    <Fade in timeout={1000}>
      <s.PageContainer>
        <PageHeader label="Parceiros" />
        <s.AssociationsContainer>
          <SearchAssociations handleSearch={searchAssociations} />
          <Draggable>
            <s.CategoriesContainer>
              <section>
                {categories.map((category) => (
                  <Button
                    key={category.key}
                    variant={
                      selectedCategory === category.key
                        ? "outlined"
                        : "contained"
                    }
                    sx={{ borderRadius: 2 }}
                    onClick={() => handleSelectCategory(category.key)}
                  >
                    {category.label}
                  </Button>
                ))}
              </section>
            </s.CategoriesContainer>
          </Draggable>
          {associationsList.map((association) => (
            <AssociationCard
              association={association}
              key={association.associationId}
            />
          ))}
        </s.AssociationsContainer>
      </s.PageContainer>
    </Fade>
  );
};

export default Associations;
